const CoconutTypes = {
  LEAD: 'Lead',
  RETAIL: 'Retail',
  NOTE: 'Note',
  TASK: 'Task',
  BENEFICIARY: 'Beneficiary',
  CORPORATE: 'Corporate',
  TRUSTEDAPIREGISTRATION: 'TrustedAPIRegistration',
  TRUSTEDAPIQUOTE: 'TrustedAPIQuote',
  TRANSACTIONAL_API_QUOTE: 'TransactionalAPIQuote',
  REGISTRATION: 'Registration',
  LOOKUP: 'Lookup',
  PERMISSION: 'Permission',
  USER: 'User',
  DOCUMENT: 'Document',
  SETTING: 'Setting',
  HISTORY: 'History',
  KYC: 'KYC',
  RATE_ALERT: 'RateAlert',
  PAYMENT: 'Payment',
  CONVERSION: 'Conversion',
  TRANSACTION: 'Transaction',
  COMPLIANCE_NOTE: 'ComplianceNote',
  RISK_SETTING: 'RiskSetting',
  SMR: 'SMR',
  NOTIFICATION: 'Notification',
  PRICING_PLAN: 'PricingPlan',
  AFFILIATE: 'Affiliate',
  OPPORTUNITY: 'Opportunity',
  CUSTOMER_NOTIFICATION: 'CustomerNotification',
  LEAD_DISTRIBUTION: 'LeadDistribution',
  MARKETING_SETTINGS: 'MarketingSettings',
  IFTI: 'IFTI',
  PRICING_STRUCTURE: 'PricingStructure',
  BULK_PAYMENT: 'BulkPayment',
  TRANSFER: 'Transfer',
  SALES_OPPORTUNITY: 'SalesOpportunity',
  QUOTE: 'Quote',
  INCOMING_FUND: 'IncomingFund',
  ATOMIC_COUNTER: 'atomicCounter',
  LEDGER_ACCOUNT: 'LedgerAccount',
  VIRTUAL_ACCOUNT: 'VirtualAccount',
  INTERNAL_ACCOUNT: 'InternalAccount',
};

const CreatedSourceTypes = {
  TRUSTED_API: 'trusted-api',
  TRANSACTIONAL_API: 'transactional-api',
};

const ApiOrganisationTypes = {
  PARTNER: 'partner',
  TRUSTED: 'trusted',
};

const LoginSourceTypes = {
  GOOGLE: 'google',
  FACEBOOK: 'facebook',
};

const VRN_ROUTING_TYPES = {
  ABA: 'aba',
  SWIFT: 'swift',
  CA_CPA: 'ca_cpa',
  AU_BSB: 'au_bsb',
  GB_SORT_CODE: 'gb_sort_code',
  IN_IFSC: 'in_ifsc',
  CNAPS: 'cnaps',
};

module.exports = {
  CoconutTypes,
  CreatedSourceTypes,
  LoginSourceTypes,
  ApiOrganisationTypes,
  VRN_ROUTING_TYPES,
};
